// @flow
import React from 'react';
import { connect } from 'react-redux';
import {
  MdSearch,
  MdAdd,
} from 'react-icons/lib/md';
import { withRouter } from 'react-router';
import i18n from 'i18n-js';

import Input from '../../../Input';

import BackendContentCountTab from '../../../BackendContentCountTab';
import ContentFiltersContainer from '../../../ContentFiltersContainer';
import ContentFiltersLeftGroup from '../../../ContentFiltersLeftGroup';
import ContentFiltersRightGroup from '../../../ContentFiltersRightGroup';
import OpenButton from '../../../OpenButton';

const ExitMethodsNavigation = ({
  isPuertasActive,
}) => (
  <ContentFiltersContainer>
    <ContentFiltersLeftGroup>
      <ExitsTab />
      <DoorsTab />
    </ContentFiltersLeftGroup>
    <ContentFiltersRightGroup>
      <Input placeholder={i18n.t('common.search')} Icon={MdSearch} clearMargins />
      {!isPuertasActive ? <OpenButton title={i18n.t('common.gateway', { count: 1 })} Icon={MdAdd} clearMargins id="createexitmethod" /> : <OpenButton title={i18n.t('common.gate', { count: 1 })} Icon={MdAdd} clearMargins id="creategate" />}
    </ContentFiltersRightGroup>
  </ContentFiltersContainer>
);

const ExitsTab = connect(
  _state => ({
    count: 5, // TODO
    to: '/admin/backend/exit-methods/list',
    title: i18n.t('common.gateway', { count: 2 }),
    isActive: (
      match,
      { pathname },
    ) => match || pathname === '/admin/backend/exit-methods',
  }),
)(BackendContentCountTab);

const DoorsTab = connect(
  _state => ({
    count: 3, // TODO
    to: '/admin/backend/exit-methods/doors',
    title: i18n.t('common.gate', { count: 2 }),
    isActive: match => match,
  }),
)(BackendContentCountTab);

export default withRouter(connect(
  _state => ({
    isPuertasActive: _state.router.location.pathname === '/admin/backend/exit-methods/doors',
  }),
)(ExitMethodsNavigation));



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendExitMethodsView/BackendExitMethodsNavigation/index.jsx